import { render, staticRenderFns } from "./BlocoCategoriaMonitoramentoAgricola.vue?vue&type=template&id=521b4ef9&scoped=true&lang=pug"
import script from "./BlocoCategoriaMonitoramentoAgricola.vue?vue&type=script&lang=js"
export * from "./BlocoCategoriaMonitoramentoAgricola.vue?vue&type=script&lang=js"
import style0 from "./BlocoCategoriaMonitoramentoAgricola.vue?vue&type=style&index=0&id=521b4ef9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "521b4ef9",
  null
  
)

export default component.exports